/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pl_Toast_Cancel_In_NoteInputs */

const vi_pl_toast_cancel_in_note = /** @type {(inputs: Pl_Toast_Cancel_In_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã hủy phiếu nhập lô chè mua`)
};

/**

* @param {Pl_Toast_Cancel_In_NoteInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pl_toast_cancel_in_note = /** @type {((inputs?: Pl_Toast_Cancel_In_NoteInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pl_Toast_Cancel_In_NoteInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pl_toast_cancel_in_note(inputs)
});